import styled from "styled-components";

export const ExportContainer = styled.div`
  padding: 20px;
`